import React from 'react';
import PropTypes from 'prop-types';

import './Filler.css';

export default function Filler(props) {
  const { percentage, background } = props;
  return <div className="filler" style={{ width: `${percentage}%`, background }} />;
}

Filler.propTypes = {
  percentage: PropTypes.number,
  background: PropTypes.string,
};

Filler.defaultProps = {
  percentage: 0,
  background: '#AAA',
};
